import PaymentsPage from "components/pages/PaymentsPage";
import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes from "model";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

export default function CaptureQuickTourPayments(props) {
    const context = useBCMSContext();
    const { branding } = context.state;
    const { options } = branding ?? {};
    BCMSRecord.globalControllerFor(Classes, context);
    const hasPayments = options.rxp17_abi22 === "true";

    if(!hasPayments) {
        const message = `This capture is only shown when "*Payments" is set to "Yes".`;
        return <CaptureNotShownView message={ message }/>;
    }
    
    return <PaymentsPage />
}